import { useMutation } from "@apollo/client";

import { CREATE_AI_INTEGRATION } from "./gql";

const useCreateAiIntegration = () => {
  return useMutation(CREATE_AI_INTEGRATION);
};

export default useCreateAiIntegration;
